import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
import MarketoIcon from 'src/legacy/images/marketo.png';
import MarketoActivationPage from './MarketoActivationPage';
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import BackButton from 'src/legacy/components/BackButton';
import { localizedStrings } from  'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';

class MarketoView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state={
      deleteConfirmation: false
    }

    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedMarketo = localizedStrings.components.integrations.marketo;
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  componentDidMount(){

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }

  }
  
  render(){
    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton className={styles.back} title={this.localizedCommons.actions.back}  onClick={() => {
              this.props.handleIntegrationsBackButton();
            }} />
            <div className={ styles.heading }>
              <Image src={MarketoIcon} />
              <h2 className={styles.name}>{ this.localizedMarketo.title }</h2>
              <p className={styles.description}>{ this.localizedMarketo.sub_text }</p>
              {this.props.integration && this.props.integration.state.code === "ok" &&
                <button className={styles.button}  onClick={this._handleDeactivateClicked}>
                 { this.localizedIntegrations.actions.deactivate }
                </button>
              }
            </div>  
          </Col>
          <Col md={9} className={styles.right}>
            <MarketoActivationPage store={this.context.store} integration = { this.props.integration }/>  
          </Col>
        
        </Row>
        <DeactivateIntegrationContainer 
          name = { this.localizedMarketo.deactivate_slider.title }
          type="marketo"
          message={ this.localizedMarketo.deactivate_slider.sub_text }
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
             deleteConfirmation: false
          })
        }}
       />   
      </div>
    );
  }
}

export default MarketoView;